import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import { drawerWidth } from "../RightUnitDrawer/RightUnitDrawerStyles";


export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            overflowY: "hidden",
            width: "100%",
            position: "relative",
        },
        mapShift: {
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            marginRight: drawerWidth,
        },
        mapNoShift: {
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginRight: 0,
        },
    }),
);
